var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46683 24.1666L5.8335 22.5333L12.3668 15.9999L5.8335 9.46659L7.46683 7.83325L14.0002 14.3666L20.5335 7.83325L22.1668 9.46659L15.6335 15.9999L22.1668 22.5333L20.5335 24.1666L14.0002 17.6333L7.46683 24.1666Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseiconwhite);
export default __webpack_public_path__ + "static/media/closeiconwhite.53f08f6e638c0540fee95a08cbb12ec2.svg";
export { ForwardRef as ReactComponent };